"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-documentation"
  }, [_c("iframe", {
    staticClass: "template-documentation",
    attrs: {
      src: _vm.url
    }
  })]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;